export default "__VITE_ASSET__B45ctoqw__"